export default __webpack_public_path__ + "static/media/StaticPage6.11d7f31a.txt";